import { createTheme } from '@mui/material/styles';

// Paleta tomada de HSM Manager (app cliente de campañas).
// Primary púrpura Cliengo, status pills en verde menta.
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#7C4DFF',
      dark: '#5E35B1',
      light: '#B39DDB',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#1976D2',
    },
    success: {
      // Verde menta usado en los chips "WhatsApp Business" de Manager.
      main: '#2E7D32',
      light: '#C8F0D8',
      dark: '#1B5E20',
      contrastText: '#1B5E20',
    },
    info: {
      // Azul Meta Cloud, usado en chips de canal Meta.
      main: '#1976D2',
      light: '#D6E8FB',
      dark: '#0D47A1',
      contrastText: '#0D47A1',
    },
    warning: {
      // Rosa/coral suave para chips "Sin canal" / "Sin línea HSM".
      main: '#C62828',
      light: '#FDDCDC',
      dark: '#8E1B1B',
      contrastText: '#8E1B1B',
    },
    background: {
      default: '#FAFAFB',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1A1F36',
      secondary: '#5A6478',
    },
    divider: '#E5E7EB',
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'Helvetica',
      'Arial',
      'sans-serif',
    ].join(','),
    h4: { fontWeight: 700, letterSpacing: '-0.01em' },
    h5: { fontWeight: 700, letterSpacing: '-0.01em' },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: 'none' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          paddingInline: 20,
          paddingBlock: 10,
          boxShadow: 'none',
        },
        contained: {
          '&:hover': { boxShadow: 'none' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid #E5E7EB',
          boxShadow: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600, borderRadius: 999 },
        colorSuccess: {
          backgroundColor: '#C8F0D8',
          color: '#1B5E20',
        },
        colorInfo: {
          backgroundColor: '#D6E8FB',
          color: '#0D47A1',
        },
        colorWarning: {
          backgroundColor: '#FDDCDC',
          color: '#8E1B1B',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
  },
});
